// Reef Chemistry Calculator JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Initialize calculator
    initializeCalculator();
});

function initializeCalculator() {
    // Set default values
    document.getElementById('currentCa').value = '380';
    document.getElementById('targetCa').value = '420';
    document.getElementById('volumeCa').value = '100';
    
    document.getElementById('currentAlk').value = '7.0';
    document.getElementById('targetAlk').value = '9.0';
    document.getElementById('volumeAlk').value = '100';
    
    document.getElementById('currentMg').value = '1200';
    document.getElementById('targetMg').value = '1350';
    document.getElementById('volumeMg').value = '100';

    // Add event listeners
    setupEventListeners();
}

function setupEventListeners() {
    // Update alkalinity target unit when source unit changes
    document.getElementById('alkUnit').addEventListener('change', function() {
        document.getElementById('alkTargetUnit').textContent = this.value;
    });

    // Show/hide custom input fields
    document.getElementById('caProduct').addEventListener('change', function() {
        const customGroup = document.getElementById('customCaGroup');
        customGroup.style.display = this.value === 'custom' ? 'block' : 'none';
    });

    document.getElementById('alkProduct').addEventListener('change', function() {
        const customGroup = document.getElementById('customAlkGroup');
        customGroup.style.display = this.value === 'custom_alk' ? 'block' : 'none';
    });

    document.getElementById('mgProduct').addEventListener('change', function() {
        const customGroup = document.getElementById('customMgGroup');
        customGroup.style.display = this.value === 'custom_mg' ? 'block' : 'none';
    });
}

// Commercial product concentrations (ppm increase per mL in 100L)
const calciumProducts = {
    'cacl2': { type: 'powder', ppmPerGram: 36 }, // per 10L
    'kalkwasser': { type: 'powder', ppmPerGram: 19 },
    'redsea_ca': { type: 'liquid', ppmPerMl: 20 },
    'redsea_calcium': { type: 'liquid', ppmPerMl: 18 },
    'seachem_reef_complete': { type: 'liquid', ppmPerMl: 16 },
    'seachem_reef_advantage': { type: 'powder', ppmPerGram: 30 },
    'brightwell_calcion': { type: 'liquid', ppmPerMl: 25 },
    'esv_calcium': { type: 'liquid', ppmPerMl: 22 },
    'esv_bionic_part1': { type: 'liquid', ppmPerMl: 20 },
    'tm_biocalcium': { type: 'liquid', ppmPerMl: 15 },
    'tm_part_a': { type: 'liquid', ppmPerMl: 18 },
    'aquaforest_calcium': { type: 'liquid', ppmPerMl: 17 },
    'kent_calcium': { type: 'liquid', ppmPerMl: 14 },
    'two_little_fishies': { type: 'liquid', ppmPerMl: 19 }
};

const alkalinityProducts = {
    'nahco3': { type: 'powder', dkhPerGram: 0.36 }, // per 10L
    'na2co3': { type: 'powder', dkhPerGram: 0.57 },
    'kalkwasser': { type: 'powder', dkhPerGram: 0.28 },
    'redsea_alk': { type: 'liquid', dkhPerMl: 0.25 },
    'redsea_alkalinity': { type: 'liquid', dkhPerMl: 0.22 },
    'seachem_reef_buffer': { type: 'powder', dkhPerGram: 0.4 },
    'seachem_marine_buffer': { type: 'powder', dkhPerGram: 0.35 },
    'brightwell_alkalin8': { type: 'liquid', dkhPerMl: 0.28 },
    'esv_bionic_part2': { type: 'liquid', dkhPerMl: 0.24 },
    'esv_alkalinity': { type: 'liquid', dkhPerMl: 0.26 },
    'tm_part_b': { type: 'liquid', dkhPerMl: 0.23 },
    'aquaforest_kh_buffer': { type: 'powder', dkhPerGram: 0.38 },
    'kent_superbuffer': { type: 'powder', dkhPerGram: 0.33 },
    'two_little_fishies_b': { type: 'liquid', dkhPerMl: 0.21 }
};

const magnesiumProducts = {
    'mgcl2': { type: 'powder', ppmPerGram: 12 }, // per 10L
    'mgso4': { type: 'powder', ppmPerGram: 10 },
    'redsea_mg': { type: 'liquid', ppmPerMl: 100 },
    'redsea_magnesium': { type: 'liquid', ppmPerMl: 95 },
    'seachem_reef_magnesium': { type: 'liquid', ppmPerMl: 80 },
    'brightwell_magnesion': { type: 'liquid', ppmPerMl: 90 },
    'esv_magnesium': { type: 'liquid', ppmPerMl: 85 },
    'tm_magnesium': { type: 'liquid', ppmPerMl: 75 },
    'aquaforest_magnesium': { type: 'liquid', ppmPerMl: 82 },
    'kent_magnesium': { type: 'liquid', ppmPerMl: 70 },
    'salifert_magnesium': { type: 'liquid', ppmPerMl: 88 }
};

// Dosing history storage
let dosingHistory = [];

function convertVolume(volume, unit) {
    return unit === 'liters' ? volume : volume * 3.78541; // Convert gallons to liters
}

function calculateCalcium() {
    const current = parseFloat(document.getElementById('currentCa').value);
    const target = parseFloat(document.getElementById('targetCa').value);
    const volume = parseFloat(document.getElementById('volumeCa').value);
    const volumeUnit = document.getElementById('volumeUnitCa').value;
    const product = document.getElementById('caProduct').value;

    if (!current || !target || !volume) {
        showResult('caResult', 'Please fill in all fields', false);
        return;
    }

    if (target <= current) {
        showResult('caResult', 'Target level must be higher than current level', false);
        return;
    }

    const volumeInLiters = convertVolume(volume, volumeUnit);
    const increase = target - current;
    let result = '';
    let amount = 0;
    let unit = '';

    if (product === 'custom') {
        const customConc = parseFloat(document.getElementById('customCaConcentration').value);
        if (!customConc) {
            showResult('caResult', 'Please enter custom product concentration', false);
            return;
        }
        amount = (increase * volumeInLiters) / (customConc / 1000);
        unit = 'mL';
        result = `Add ${amount.toFixed(2)} mL of your custom calcium supplement`;
    } else if (calciumProducts[product]) {
        const productInfo = calciumProducts[product];
        if (productInfo.type === 'powder') {
            amount = (increase * volumeInLiters) / (productInfo.ppmPerGram * 10);
            unit = 'g';
            result = `Add ${amount.toFixed(2)}g of ${getProductName(product)}`;
        } else {
            amount = (increase * volumeInLiters) / productInfo.ppmPerMl;
            unit = 'mL';
            result = `Add ${amount.toFixed(2)} mL of ${getProductName(product)}`;
        }
    } else {
        result = `Product not found. Please select a valid product.`;
    }

    showResult('caResult', result, true);
    
    // Add to dosing history
    if (amount > 0) {
        addToDosingHistory('Calcium', amount, unit, getProductName(product));
    }
    
    // Show alerts for large doses
    showDosingAlerts('ca', amount, unit);
}

function calculateAlkalinity() {
    let current = parseFloat(document.getElementById('currentAlk').value);
    let target = parseFloat(document.getElementById('targetAlk').value);
    const volume = parseFloat(document.getElementById('volumeAlk').value);
    const volumeUnit = document.getElementById('volumeUnitAlk').value;
    const unit = document.getElementById('alkUnit').value;
    const product = document.getElementById('alkProduct').value;

    if (!current || !target || !volume) {
        showResult('alkResult', 'Please fill in all fields', false);
        return;
    }

    if (target <= current) {
        showResult('alkResult', 'Target level must be higher than current level', false);
        return;
    }

    // Convert to dKH if needed
    if (unit === 'meql') {
        current *= 2.8;
        target *= 2.8;
    } else if (unit === 'ppm') {
        current /= 17.9;
        target /= 17.9;
    }

    const volumeInLiters = convertVolume(volume, volumeUnit);
    const increase = target - current;
    let result = '';
    let amount = 0;
    let doseUnit = '';

    if (product === 'custom_alk') {
        const customConc = parseFloat(document.getElementById('customAlkConcentration').value);
        if (!customConc) {
            showResult('alkResult', 'Please enter custom product concentration', false);
            return;
        }
        amount = (increase * volumeInLiters) / customConc;
        doseUnit = 'mL';
        result = `Add ${amount.toFixed(2)} mL of your custom alkalinity supplement`;
    } else if (alkalinityProducts[product]) {
        const productInfo = alkalinityProducts[product];
        if (productInfo.type === 'powder') {
            amount = (increase * volumeInLiters) / (productInfo.dkhPerGram * 10);
            doseUnit = 'g';
            result = `Add ${amount.toFixed(2)}g of ${getProductName(product)}`;
        } else {
            amount = (increase * volumeInLiters) / productInfo.dkhPerMl;
            doseUnit = 'mL';
            result = `Add ${amount.toFixed(2)} mL of ${getProductName(product)}`;
        }
    } else {
        result = `Product not found. Please select a valid product.`;
    }

    showResult('alkResult', result, true);
    
    // Add to dosing history
    if (amount > 0) {
        addToDosingHistory('Alkalinity', amount, doseUnit, getProductName(product));
    }
    
    // Show alerts for large doses
    showDosingAlerts('alk', amount, doseUnit);
}

function calculateMagnesium() {
    const current = parseFloat(document.getElementById('currentMg').value);
    const target = parseFloat(document.getElementById('targetMg').value);
    const volume = parseFloat(document.getElementById('volumeMg').value);
    const volumeUnit = document.getElementById('volumeUnitMg').value;
    const product = document.getElementById('mgProduct').value;

    if (!current || !target || !volume) {
        showResult('mgResult', 'Please fill in all fields', false);
        return;
    }

    if (target <= current) {
        showResult('mgResult', 'Target level must be higher than current level', false);
        return;
    }

    const volumeInLiters = convertVolume(volume, volumeUnit);
    const increase = target - current;
    let result = '';
    let amount = 0;
    let unit = '';

    if (product === 'custom_mg') {
        const customConc = parseFloat(document.getElementById('customMgConcentration').value);
        if (!customConc) {
            showResult('mgResult', 'Please enter custom product concentration', false);
            return;
        }
        amount = (increase * volumeInLiters) / (customConc / 1000);
        unit = 'mL';
        result = `Add ${amount.toFixed(2)} mL of your custom magnesium supplement`;
    } else if (magnesiumProducts[product]) {
        const productInfo = magnesiumProducts[product];
        if (productInfo.type === 'powder') {
            amount = (increase * volumeInLiters) / (productInfo.ppmPerGram * 10);
            unit = 'g';
            result = `Add ${amount.toFixed(2)}g of ${getProductName(product)}`;
        } else {
            amount = (increase * volumeInLiters) / productInfo.ppmPerMl;
            unit = 'mL';
            result = `Add ${amount.toFixed(2)} mL of ${getProductName(product)}`;
        }
    } else {
        result = `Product not found. Please select a valid product.`;
    }

    showResult('mgResult', result, true);
    
    // Add to dosing history
    if (amount > 0) {
        addToDosingHistory('Magnesium', amount, unit, getProductName(product));
    }
    
    // Show alerts for large doses
    showDosingAlerts('mg', amount, unit);
}

function getProductName(productCode) {
    const names = {
        'cacl2': 'Calcium Chloride',
        'kalkwasser': 'Kalkwasser',
        'redsea_ca': 'Red Sea Reef Foundation A',
        'redsea_calcium': 'Red Sea Calcium Pro',
        'seachem_reef_complete': 'Seachem Reef Complete',
        'seachem_reef_advantage': 'Seachem Reef Advantage Calcium',
        'brightwell_calcion': 'Brightwell Calcion',
        'esv_calcium': 'ESV B-Ionic Calcium',
        'esv_bionic_part1': 'ESV B-Ionic Part 1',
        'tm_biocalcium': 'Tropic Marin Bio-Calcium',
        'tm_part_a': 'Tropic Marin Part A',
        'aquaforest_calcium': 'Aquaforest Calcium',
        'kent_calcium': 'Kent Marine Liquid Calcium',
        'two_little_fishies': 'Two Little Fishies C-Balance A',
        'nahco3': 'Sodium Bicarbonate',
        'na2co3': 'Sodium Carbonate',
        'redsea_alk': 'Red Sea Reef Foundation B',
        'redsea_alkalinity': 'Red Sea Alkalinity Pro',
        'seachem_reef_buffer': 'Seachem Reef Buffer',
        'seachem_marine_buffer': 'Seachem Marine Buffer',
        'brightwell_alkalin8': 'Brightwell Alkalin8.3',
        'esv_bionic_part2': 'ESV B-Ionic Part 2',
        'esv_alkalinity': 'ESV Alkalinity',
        'tm_part_b': 'Tropic Marin Part B',
        'aquaforest_kh_buffer': 'Aquaforest KH Buffer',
        'kent_superbuffer': 'Kent Marine Super Buffer',
        'two_little_fishies_b': 'Two Little Fishies C-Balance B',
        'mgcl2': 'Magnesium Chloride',
        'mgso4': 'Magnesium Sulfate (Epsom Salt)',
        'redsea_mg': 'Red Sea Reef Foundation C',
        'redsea_magnesium': 'Red Sea Magnesium Pro',
        'seachem_reef_magnesium': 'Seachem Reef Magnesium',
        'brightwell_magnesion': 'Brightwell Magnesion',
        'esv_magnesium': 'ESV Magnesium',
        'tm_magnesium': 'Tropic Marin Magnesium',
        'aquaforest_magnesium': 'Aquaforest Magnesium',
        'kent_magnesium': 'Kent Marine Magnesium',
        'salifert_magnesium': 'Salifert Magnesium Supplement'
    };
    return names[productCode] || productCode;
}

function showResult(elementId, message, isSuccess) {
    const resultElement = document.getElementById(elementId);
    if (resultElement) {
        resultElement.textContent = message;
        resultElement.style.background = isSuccess 
            ? 'linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%)'
            : 'linear-gradient(135deg, #ff6b6b 0%, #feca57 100%)';
        resultElement.classList.add('show');
    }
}

function showDosingAlerts(parameter, amount, unit) {
    const alertsElement = document.getElementById(parameter + 'Alerts');
    if (!alertsElement) return;
    
    let alertHtml = '';
    
    // Define thresholds for warnings
    const thresholds = {
        ca: { warning: unit === 'mL' ? 10 : 5, danger: unit === 'mL' ? 20 : 10 },
        alk: { warning: unit === 'mL' ? 5 : 2, danger: unit === 'mL' ? 10 : 5 },
        mg: { warning: unit === 'mL' ? 15 : 8, danger: unit === 'mL' ? 30 : 15 }
    };
    
    if (amount > thresholds[parameter].danger) {
        alertHtml = '<div class="alert danger">⚠️ Large dose detected! Consider splitting this dose over multiple days.</div>';
    } else if (amount > thresholds[parameter].warning) {
        alertHtml = '<div class="alert warning">⚠️ Moderate dose. Monitor parameters closely after dosing.</div>';
    }
    
    alertsElement.innerHTML = alertHtml;
}

function addToDosingHistory(parameter, amount, unit, product) {
    const now = new Date();
    const timeString = now.toLocaleTimeString();
    
    dosingHistory.push({
        time: timeString,
        parameter: parameter,
        amount: amount,
        unit: unit,
        product: product
    });
    
    updateDosingHistoryDisplay();
    updateDailyTotal();
}

function updateDosingHistoryDisplay() {
    const historyElement = document.getElementById('dosingHistoryList');
    if (!historyElement) return;
    
    if (dosingHistory.length === 0) {
        historyElement.innerHTML = '<p style="color: #666; font-style: italic;">No doses recorded today</p>';
        return;
    }
    
    let historyHtml = '';
    dosingHistory.forEach((dose, index) => {
        historyHtml += `
            <div class="history-item">
                <div>
                    <strong>${dose.time}</strong> - ${dose.parameter}: ${dose.amount.toFixed(2)}${dose.unit} of ${dose.product}
                </div>
                <button class="undo-btn" onclick="removeDose(${index})">Undo</button>
            </div>
        `;
    });
    
    historyElement.innerHTML = historyHtml;
}

function updateDailyTotal() {
    const totalElement = document.getElementById('dailyTotal');
    if (!totalElement) return;
    
    if (dosingHistory.length === 0) {
        totalElement.textContent = '📊 Today\'s Dosing: No doses recorded yet';
        return;
    }
    
    const summary = dosingHistory.reduce((acc, dose) => {
        if (!acc[dose.parameter]) {
            acc[dose.parameter] = { count: 0, amounts: [] };
        }
        acc[dose.parameter].count++;
        acc[dose.parameter].amounts.push(`${dose.amount.toFixed(1)}${dose.unit}`);
        return acc;
    }, {});
    
    let summaryText = '📊 Today\'s Dosing: ';
    const summaryParts = Object.keys(summary).map(param => 
        `${param}: ${summary[param].count} dose${summary[param].count > 1 ? 's' : ''}`
    );
    
    totalElement.textContent = summaryText + summaryParts.join(', ');
}

function removeDose(index) {
    dosingHistory.splice(index, 1);
    updateDosingHistoryDisplay();
    updateDailyTotal();
}

function clearHistory() {
    dosingHistory = [];
    updateDosingHistoryDisplay();
    updateDailyTotal();
}

function quickDose(parameter, increase) {
    // Get current volume (use first available volume input)
    let volume = 100; // default
    let volumeUnit = 'gallons';
    
    if (parameter === 'ca') {
        volume = parseFloat(document.getElementById('volumeCa').value) || 100;
        volumeUnit = document.getElementById('volumeUnitCa').value;
    } else if (parameter === 'alk') {
        volume = parseFloat(document.getElementById('volumeAlk').value) || 100;
        volumeUnit = document.getElementById('volumeUnitAlk').value;
    } else if (parameter === 'mg') {
        volume = parseFloat(document.getElementById('volumeMg').value) || 100;
        volumeUnit = document.getElementById('volumeUnitMg').value;
    }
    
    const volumeInLiters = convertVolume(volume, volumeUnit);
    let amount = 0;
    let unit = '';
    let product = '';
    
    // Calculate quick dose amounts using default products
    if (parameter === 'ca') {
        // Use calcium chloride as default
        amount = (increase * volumeInLiters) / (36 * 10); // 36 ppm per gram per 10L
        unit = 'g';
        product = 'Calcium Chloride (Quick Dose)';
    } else if (parameter === 'alk') {
        // Use sodium bicarbonate as default
        amount = (increase * volumeInLiters) / (0.36 * 10); // 0.36 dKH per gram per 10L
        unit = 'g';
        product = 'Sodium Bicarbonate (Quick Dose)';
    } else if (parameter === 'mg') {
        // Use magnesium chloride as default
        amount = (increase * volumeInLiters) / (12 * 10); // 12 ppm per gram per 10L
        unit = 'g';
        product = 'Magnesium Chloride (Quick Dose)';
    }
    
    // Add to dosing history
    const parameterName = parameter === 'ca' ? 'Calcium' : 
                         parameter === 'alk' ? 'Alkalinity' : 'Magnesium';
    addToDosingHistory(parameterName, amount, unit, product);
    
    // Show quick confirmation
    showQuickDoseConfirmation(parameterName, amount, unit, increase);
}

function showQuickDoseConfirmation(parameter, amount, unit, increase) {
    // Create temporary notification
    const notification = document.createElement('div');
    notification.className = 'alert info';
    notification.style.position = 'fixed';
    notification.style.top = '20px';
    notification.style.right = '20px';
    notification.style.zIndex = '1000';
    notification.style.maxWidth = '300px';
    notification.innerHTML = `✅ Quick dose added: ${amount.toFixed(2)}${unit} for +${increase} ${parameter}`;
    
    document.body.appendChild(notification);
    
    // Remove after 3 seconds
    setTimeout(() => {
        if (notification.parentNode) {
            notification.parentNode.removeChild(notification);
        }
    }, 3000);
}

function toggleSplitDose(parameter) {
    const controlsElement = document.getElementById(parameter + 'SplitControls');
    if (controlsElement) {
        controlsElement.classList.toggle('show');
    }
}

function generateSplitSchedule(parameter) {
    const daysElement = document.getElementById(parameter + 'SplitDays');
    const scheduleElement = document.getElementById(parameter + 'SplitSchedule');
    
    if (!daysElement || !scheduleElement) return;
    
    const days = parseInt(daysElement.value);
    if (!days || days < 2 || days > 7) {
        alert('Please enter a valid number of days (2-7)');
        return;
    }
    
    // Get the last calculated dose amount
    const resultElement = document.getElementById(parameter + 'Result');
    if (!resultElement || !resultElement.textContent.includes('Add')) {
        alert('Please calculate a dose first');
        return;
    }
    
    // Extract amount from result text (simple parsing)
    const resultText = resultElement.textContent;
    const match = resultText.match(/Add\s+([\d.]+)\s*(\w+)/);
    
    if (!match) {
        alert('Could not parse dose amount');
        return;
    }
    
    const totalAmount = parseFloat(match[1]);
    const unit = match[2];
    const dailyAmount = totalAmount / days;
    
    let scheduleHtml = '<h5>Daily Dose Schedule:</h5>';
    for (let i = 1; i <= days; i++) {
        scheduleHtml += `
            <div class="dose-part">
                <strong>Day ${i}</strong><br>
                ${dailyAmount.toFixed(2)} ${unit}
            </div>
        `;
    }
    
    scheduleElement.innerHTML = scheduleHtml;
}

// Temperature compensation (placeholder for future enhancement)
function getTemperatureCompensation() {
    const temp = parseFloat(document.getElementById('tankTemp').value);
    const unit = document.getElementById('tempUnit').value;
    
    // Convert to Celsius if needed
    const tempC = unit === 'F' ? (temp - 32) * 5/9 : temp;
    
    // Basic temperature compensation factor (simplified)
    // Solubility generally decreases with temperature for these compounds
    if (tempC < 24) return 1.05; // Slightly more needed at lower temps
    if (tempC > 28) return 0.95; // Slightly less needed at higher temps
    return 1.0; // Normal dosing at ideal temp range
}

// Enhanced calculation functions with temperature compensation
function calculateCalciumWithTemp() {
    const tempFactor = getTemperatureCompensation();
    // This would modify the original calculation
    // Implementation depends on specific requirements
}

// Storage functions for persistent data (using localStorage if available)
function saveDosingHistory() {
    if (typeof(Storage) !== "undefined") {
        const today = new Date().toDateString();
        localStorage.setItem('reefCalc_history_' + today, JSON.stringify(dosingHistory));
    }
}

function loadDosingHistory() {
    if (typeof(Storage) !== "undefined") {
        const today = new Date().toDateString();
        const saved = localStorage.getItem('reefCalc_history_' + today);
        if (saved) {
            dosingHistory = JSON.parse(saved);
            updateDosingHistoryDisplay();
            updateDailyTotal();
        }
    }
}

// Initialize dosing history on page load
document.addEventListener('DOMContentLoaded', function() {
    loadDosingHistory();
    
    // Save history whenever it changes
    const originalAddToHistory = addToDosingHistory;
    addToDosingHistory = function(...args) {
        originalAddToHistory.apply(this, args);
        saveDosingHistory();
    };
});

// Form validation helpers
function validateInputs(current, target, volume) {
    const errors = [];
    
    if (!current || current <= 0) {
        errors.push('Current level must be a positive number');
    }
    
    if (!target || target <= 0) {
        errors.push('Target level must be a positive number');
    }
    
    if (!volume || volume <= 0) {
        errors.push('Volume must be a positive number');
    }
    
    if (current && target && target <= current) {
        errors.push('Target level must be higher than current level');
    }
    
    return errors;
}

// Enhanced error handling
function showValidationErrors(elementId, errors) {
    const alertsElement = document.getElementById(elementId.replace('Result', 'Alerts'));
    if (alertsElement && errors.length > 0) {
        const errorHtml = errors.map(error => 
            `<div class="alert danger">❌ ${error}</div>`
        ).join('');
        alertsElement.innerHTML = errorHtml;
    }
}

// Export functions to global scope for onclick handlers
window.calculateCalcium = calculateCalcium;
window.calculateAlkalinity = calculateAlkalinity;
window.calculateMagnesium = calculateMagnesium;
window.quickDose = quickDose;
window.toggleSplitDose = toggleSplitDose;
window.generateSplitSchedule = generateSplitSchedule;
window.removeDose = removeDose;
window.clearHistory = clearHistory;